import { render, staticRenderFns } from "./AuthFormLayoutBuilder.vue?vue&type=template&id=2e536b95&scoped=true"
import script from "./AuthFormLayoutBuilder.vue?vue&type=script&lang=js"
export * from "./AuthFormLayoutBuilder.vue?vue&type=script&lang=js"
import style0 from "./AuthFormLayoutBuilder.vue?vue&type=style&index=0&id=2e536b95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e536b95",
  null
  
)

export default component.exports